import constants from "../constants.js";

export const EnhancedPolicyWeight = {
  displayName: "Weight (Highest weight will apply in conflicting policy settings)",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.Weight",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 1000,
  step: 1,
};

const TravellerConfigurationProfilePnrBuilder = {
  displayName: "Traveler Configuration Profile PNR Builder",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ProfilePnrBuilder",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

export const ApplyVirtualCreditCard = {
  displayName: "Apply Virtual Credit Card",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ApplyVirtualCreditCard",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "HotelApplyVirtualCreditCardTypes",
  defaultValue: null,
  allowNullable: true,
}

//Start FlightModificationSettingGdsProviders
export const FlightModificationSettingGdsProviders = {
  displayName: "Gds Providers",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

export const FlightModificationSettingCarriersExcluded = {
  displayName: "Carriers Excluded",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const FlightModificationSettingCarriersIncluded = {
  displayName: "Carriers Included",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const FlightModificationSettingEnableCancelRebook = {
  displayName: "Enable Cancel Rebook",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
export const FlightModificationSettingEnableExchanges = {
  displayName: "Enable Exchanges",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
export const FlightModificationSettingEnableAdd = {
  displayName: "Enable Add",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
export const EnhancedPolicyFlightModificationSettingItem = {
  displayName: "Item",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightModificationSettingGdsProviders,FlightModificationSettingCarriersExcluded,
    FlightModificationSettingCarriersIncluded,
    FlightModificationSettingEnableCancelRebook,
    FlightModificationSettingEnableExchanges,
    FlightModificationSettingEnableAdd
  ],
  endpoint: "EnhancedPolicyRules",
  removeParamId: "iiflightModificationSettingItem",
  canDelete: true,
};
export const EnhancedPolicyFlightModificationSettingsGrid = {
  tabName: "Flight-Modification-Settings",
  displayName: "Flight Modification Settings",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: EnhancedPolicyFlightModificationSettingItem,
  gridCols: [
    { name: "Providers", key: "GdsProviders" },
    { name: "CancelRebook", key: "EnableCancelRebook" },
    { name: "Exchanges", key: "EnableExchanges" },
    { name: "Add", key: "EnableAdd" },
    { name: "Excluded", key: "CarriersExcluded" },
    { name: "Included", key: "CarriersIncluded" },
  ]
};
//End FlightModificationSettingGdsProviders

//Start FlightSearch
export const EnhancedPolicyFlightSearchConfigurationConfigurationType = {
  displayName: "Flight Search Configuration Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.ConfigurationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationType"
};

export const FlightSearchConfigurationCarrierType = {
  displayName: "Carrier Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsType",
  helpText: "Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."
};

export const FlightSearchConfigurationCarriers = {
  displayName: "Carriers",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "<span class=\"help-block\">" +
      "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" +
      "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" +
      "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." +
      "</span>"
};

export const FlightSearchConfigurationExcludeCarriers = {
  displayName: "Exclude Carriers",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"
};

export const FlightSearchConfigurationCabinType = {
  displayName: "Cabin Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsTypeMultiOnly",
  helpText: "Sabre only supports single cabin queries. Therefore Multi is the only available option."
};

export const FlightSearchConfigurationCabins = {
  displayName: "Cabins",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightCabins"
};

export const FlightSearchPassengerTypes = {
  displayName: "Passenger Types",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PassengerTypes",
  allowFreeform: true,
  transformUppercase: true,
  validationRegex: "^[A-Z0-9]{3}$",
  validationMessage: "Each passenger type must be exactly 3 alphanumeric characters",
};

export const FlightSearchConfigurationIncDebtorPreferred = {
  displayName: "Include Debtor Preferred",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

export const FlightSearchConfigurationRefundableSearch = {
  displayName: "Penalty Search Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PenaltySearchTypes",
};

export const FlightSearchConfigurationUnbrandedSearch = {
  displayName: "Unbranded Search",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

export const FlightSearchConfigurationEnableATPCO = {
  displayName: "Enable ATPCO",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

export const FlightSearchConfigurationEnableNDC = {
  displayName: "Enable NDC",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."
};
export const FlightSearchConfigurationMaxStopsQuantity = {
  displayName: "Max Stops Quantity",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
export const FlightSearchConfigurationCountryOrigin = {
  displayName: "Origin Countries",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Origin country codes are in the list. ** Named list support"
};
export const FlightSearchConfigurationCountryDestination = {
  displayName: "Destination Countries",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Destination country codes are in the list. ** Named list support"
};


const FlightSearchConfigurationPriority = {
  displayName: "Priority",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightConfigurationPriority",
  html:"Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."
};

const FlightSearchConfigurationKeepSameCabin = {
  displayName: "Keep Same Cabin",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationFareFocusRulesExclude = {
  displayName: "Fare Focus Rules Exclude",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationOfferControlRulesExclude = {
  displayName: "Offer Control Rules Exclude",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationItineraryCount = {
  displayName: "Itinerary Count",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationNumTrips = {
  displayName: "Num Trips",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne = {
  displayName: "Vendor Pref Applicability AtLeast One",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationCarrierFilterApplyValidatingCarrier = {
  displayName: "Carrier Filter Apply Validating Carrier",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationDiversityHandling = {
  displayName: "Carrier Filter Apply Validating Carrier",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DiversityHandlingType"
};

const FlightSearchConfigurationAdditionalNonStopsPercentage = {
  displayName: "Additional NonStops Percentage",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketFareCutOffPercentage = {
  displayName: "Low Fare Bucket Fare Cut Off Percentage",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketOptionsPercentage = {
  displayName: "Low FareBucket Options Percentage",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",
  helpText: "BFM Configuration leave blank for default configuration.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationSetBrandedFareOptions = {
  displayName: "Set BrandedF are Options",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",
  helpText: "When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationMultipleBrandedFare = {
  displayName: "Multiple Branded Fare",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationSingleBrandedFare = {
  displayName: "Single Branded Fare",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationTimeWindowsOutbound = {
  displayName: "Time Windows Outbound",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + 
  "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + 
  "Example all day: 00002359<br/>" + 
  "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time.",
};

const FlightSearchConfigurationTimeWindowRange = {
  displayName: "Time Window Range (Min)",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",
  helpText: "Overrides configuration with defined plus and minus time wondow for searched for time.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const FlightSearchConfigurationIsCombinable = {
  displayName: "Is Combinable",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",
  helpText: "Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationIncludeCountryCarriers = {
  displayName: "Include Country Carriers",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",
  helpText: "System to include Country Carriers in carrier list. Based on origin and destination countries.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true,
};



export const EnhancedPolicyFlightSearchConfigurationItem = {
  displayName: "Item",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightSearchConfigurationCarrierType,
    FlightSearchConfigurationCarriers,
    FlightSearchConfigurationExcludeCarriers,
    FlightSearchConfigurationCabinType,
    FlightSearchConfigurationCabins,
    FlightSearchConfigurationRefundableSearch,
    FlightSearchPassengerTypes,
    FlightSearchConfigurationIncDebtorPreferred,
    FlightSearchConfigurationUnbrandedSearch,
    FlightSearchConfigurationEnableATPCO,
    FlightSearchConfigurationEnableNDC,
    FlightSearchConfigurationMaxStopsQuantity,
    FlightSearchConfigurationCountryOrigin,
    FlightSearchConfigurationCountryDestination,

    FlightSearchConfigurationIsCombinable,
    FlightSearchConfigurationIncludeCountryCarriers,
    FlightSearchConfigurationTimeWindowsOutbound,
    FlightSearchConfigurationTimeWindowRange,
    FlightSearchConfigurationPriority,
    FlightSearchConfigurationKeepSameCabin,
    FlightSearchConfigurationFareFocusRulesExclude,
    FlightSearchConfigurationOfferControlRulesExclude,
    FlightSearchConfigurationItineraryCount,
    FlightSearchConfigurationNumTrips,
    FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne,
    FlightSearchConfigurationCarrierFilterApplyValidatingCarrier,
    FlightSearchConfigurationDiversityHandling,
    FlightSearchConfigurationAdditionalNonStopsPercentage,
    FlightSearchConfigurationLowFareBucketFareCutOffPercentage,
    FlightSearchConfigurationLowFareBucketOptionsPercentage,
    FlightSearchConfigurationSetBrandedFareOptions,
    FlightSearchConfigurationMultipleBrandedFare,
    FlightSearchConfigurationSingleBrandedFare,
],
  endpoint: "EnhancedPolicyRules",
  removeParamId: "iflightSearchConfigurationItem",
  canDelete: true,
};
export const EnhancedPolicyFlightSearchGrid = {
  tabName: "Flight-Search-Configuration",
  displayName: "Flight Search Configuration",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: EnhancedPolicyFlightSearchConfigurationItem,
  gridCols: [
    { name: "CrrT", key: "CarrierType" },
    { name: "Crrs", key: "Carriers" },
    { name: "ExCrrs", key: "ExcludeCarriers" },
    { name: "CbnT", key: "CabinType" },
    { name: "Cbn", key: "Cabins" },
    { name: "Rfd", key: "RefundableSearchTypes" },
    { name: "Pax", key: "PassengerTypes" },
    { name: "Pref", key: "IncDebtorPreferred" },
    { name: "UnBrd", key: "UnbrandedSearch" },
    { name: "ATPCO", key: "EnableATPCO" },
    { name: "NDC", key: "EnableNDC" },
    { name: "Stp", key: "MaxStopsQuantity" },
    { name: "Org", key: "CountryOrigin" },
    { name: "Dst", key: "CountryDestination" },
  ]
};
//End FlightSearch

//Start FlightNdcAtpcoTieSettings
const FlightNdcAtpcoTieSettingsApplicationType = {
  displayName: "NDC ATPCO Tie Settings Application Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ApplicationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsApplicationType",
  allowNullable: true,
  html:constants.MESSAGES.NDC_TIE_SETTINGS
};

const FlightNdcAtpcoTieSettingsThresholdType = {
  displayName: "NDC ATPCO Tie Settings Threshold Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ThresholdType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsThresholdType",
};

const FlightNdcAtpcoTieSettingsThresholdValue = {
  displayName: "NDC ATPCO Tie Settings Threshold Value",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ThresholdValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
//End FlightNdcAtpcoTieSettings

const DebtorAgencyConfirmationEmailHeaderText = {
  displayName: "Confirmation Email Custom Header",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ConfirmationEmailHeaderText",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  validationMessage: "Max length 250",
  validationRegex: "^.{1,250}$"
};

const DebtorAgencyConfirmationEmailFooterText = {
  displayName: "Confirmation Email Custom Footer",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ConfirmationEmailFooterText",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  validationMessage: "Max length 250",
  validationRegex: "^.{1,250}$"
};

const EnableNewUiHandlingTypeEnhancedPolicy = {
  displayName: "Enable New UI",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.EnableNewUiHandlingType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "EnableNewUiHandlingType",
  allowNullable: true,
  defaultValue: null,
};

export const EnhancedPolicyRulesActionsPolicySettingsItem = {
  displayName: "Actions Policy Settings",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyWeight,
    ApplyVirtualCreditCard,
    TravellerConfigurationProfilePnrBuilder,
    EnhancedPolicyFlightModificationSettingsGrid,
    EnhancedPolicyFlightSearchConfigurationConfigurationType,
    EnhancedPolicyFlightSearchGrid,
    FlightNdcAtpcoTieSettingsApplicationType,
    FlightNdcAtpcoTieSettingsThresholdType,
    FlightNdcAtpcoTieSettingsThresholdValue,
    DebtorAgencyConfirmationEmailHeaderText,
    DebtorAgencyConfirmationEmailFooterText,
    EnableNewUiHandlingTypeEnhancedPolicy
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsPolicySettingsItem",
  canDelete: true,
};


// WEBPACK FOOTER //
// ./src/config/fields/enhancedPolicyRulesPolicySettings.js